<cs-header>
  <cs-header-title>{{ LL.intake.updateOptions.title() }}</cs-header-title>
</cs-header>

<cs-content (scroll)="onContentScroll()" (window:resize)="onWindowResize()">
  <cs-item-list>
    <cs-note big class="update-options-intro">{{ LL.intake.updateOptions.intro() }}</cs-note>

    <!-- what happens to the training program -->
    <cs-item-group small [title]="LL.intake.updateOptions.workoutsTitle()">
      <cs-radio-group [(selected)]="workouts" (selectedChange)="onWorkoutsChange()">
        <cs-radio [value]="WorkoutsUpdateChoice.Rebuild" [recommended]="true">
          {{ LL.intake.updateOptions.workoutsRebuild() }}
          <cs-note>{{ getWorkoutsRebuildNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="WorkoutsUpdateChoice.VolumesOnly">
          {{ LL.intake.updateOptions.workoutsVolumesOnly() }}
          <cs-note>{{ LL.intake.updateOptions.workoutsVolumesOnlyNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="WorkoutsUpdateChoice.Keep">
          {{ LL.intake.updateOptions.workoutsKeep() }}
          <cs-note>{{ LL.intake.updateOptions.workoutsKeepNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-item-group>

    @if (askAboutNutrition) {
    <!-- what happens to the daily calorie target -->
    <cs-item-group small [title]="LL.intake.updateOptions.nutritionTitle()">
      <cs-radio-group [(selected)]="nutrition" (selectedChange)="onNutritionChange()">
        <cs-radio [value]="NutritionUpdateChoice.Update">
          {{ LL.intake.updateOptions.nutritionUpdate() }}
          <cs-note>{{ LL.intake.updateOptions.nutritionUpdateNote() }}</cs-note>
        </cs-radio>
        <cs-radio [value]="NutritionUpdateChoice.Keep">
          {{ LL.intake.updateOptions.nutritionKeep() }}
          <cs-note>{{ getNutritionKeepNote() }}</cs-note>
        </cs-radio>
      </cs-radio-group>
    </cs-item-group>

    <!--
      Warnings and info, never blocks. Every combination below is allowed on purpose — the
      user is told what their answer costs and still decides (#4973).

      WARNING (orange) means the answer contradicts a change the user just made. INFO (blue)
      means the answer is sensible and this is what it costs. The two can never appear
      together: the warnings all require Keep and the info requires Update.

      The wrapper is what the page measures to decide whether these have been seen — see
      `messagesSeen` in the component. Keep every card inside it.
    -->
    <div #messagesBlock>
    @if (showKeepEnergyBalanceWarning()) {
      <cs-info-card type="warning" [dismissible]="false" class="update-options-warning">
        {{ LL.intake.updateOptions.warnKeepEnergyBalance() }}
      </cs-info-card>
    }
    @if (showKeepGoalWarning()) {
      <cs-info-card type="warning" [dismissible]="false" class="update-options-warning">
        {{ LL.intake.updateOptions.warnKeepGoal() }}
      </cs-info-card>
    }
    @if (showKeepBodyDataWarning()) {
      <cs-info-card type="warning" [dismissible]="false" class="update-options-warning">
        {{ LL.intake.updateOptions.warnKeepBodyData() }}
      </cs-info-card>
    }
    @if (showKeepActivityLevelWarning()) {
      <cs-info-card type="warning" [dismissible]="false" class="update-options-warning">
        {{ LL.intake.updateOptions.warnKeepActivityLevel() }}
      </cs-info-card>
    }
    @if (showUpdateReplacesTargetWarning()) {
      <cs-info-card type="info" [dismissible]="false" class="update-options-warning">
        {{ getUpdateReplacesTargetText() }}
      </cs-info-card>
    }
    </div>
    }
  </cs-item-list>
</cs-content>

<!-- shown exactly while Continue is held, so the way to free it is always on screen -->
@if (showScrollHint()) {
  <button type="button" class="update-options-scroll-hint" (click)="handleScrollToMessages()"
    [style.bottom.px]="scrollHintBottom_px"
    [attr.aria-label]="LL.intake.updateOptions.scrollToMessages()">
    <cs-icon name="arrow-point-down"></cs-icon>
  </button>
}

<cs-page-action-buttons #actionButtons [showCancel]="true" (cancel)="handleCancel($event)">
  <cs-button primary medium [disabled]="isContinueBlocked()" [label]="LL.common.buttons.continue()"
    (click)="handleContinue($event)"></cs-button>
</cs-page-action-buttons>
